export const ApiBase = `${process.env.REACT_APP_API_URL}/v1`
export const AuthApiBase = process.env.REACT_APP_API_URL

// AUTH
const SIGNUP = `${AuthApiBase}/accounts/signup/`
const LOGIN = `${AuthApiBase}/accounts/login/`
const LOGIN_SOCIAL = `${AuthApiBase}/accounts/social/login/`
const DEPRECATED_LOGIN_SOCIAL = `${AuthApiBase}/accounts/social/token/`
const SET_VERIFY_USER = (code) =>
  `${AuthApiBase}/accounts/signup/${code}/verify/`
const VERIFY_USER = (code) => `${AuthApiBase}/accounts/signup/${code}`
const VERIFY_RESET_PASSWORD = (code) =>
  `${AuthApiBase}/accounts/password/reset/verify/?code=${code}`
const SET_PASSWORD = `${AuthApiBase}/accounts/password/setup/`
const RESET_PASSWORD = `${AuthApiBase}/accounts/password/reset/verified/`
const FORGOT_PASSWORD = `${AuthApiBase}/accounts/password/reset/`
const USER_ME = `${AuthApiBase}/accounts/users/me/`
const LOGOUT = `${AuthApiBase}/accounts/logout/`
const CHANGE_PASSWORD = `${AuthApiBase}/accounts/password/change/`
const CHANGE_EMAIL = `${AuthApiBase}/accounts/email/change/`
const SOCIAL_PROVIDERS = `${AuthApiBase}/accounts/social/providers/`
const RESEND_VERIFICATION_EMAIL = `${AuthApiBase}/accounts/verification-email/resend`
const EMAIL_CHANGE_VERIFY = (code) =>
  `${AuthApiBase}/accounts/email/change/verify/?code=${code}`
const COGNITO_SYNC = `${AuthApiBase}/accounts/cognito/sync/`

const GET_RESOURCE = (id) => `${ApiBase}/resources/${id}`

// FORMS
const GET_FORMS = (limit) => `${ApiBase}/forms?limit=${limit}`
const GET_TIME_AND_IP = `${ApiBase}/time`
const CLONE_FORM = (formId) => `${ApiBase}/forms/clone/${formId}`
const CONVERT_FORMS = `${ApiBase}/form-creation-request`

// CALCULATION
const CALCULATION_RESULT = (questionId) =>
  `${ApiBase}/questions/${questionId}/calculation`

// CLIENTS
const CLIENTS_MERGE = (masterClientId) =>
  `${ApiBase}/customers/merge/${masterClientId}`

// CALENDAR
const APPOINTMENTS = `${ApiBase}/calendar/appointments`
const WORKFLOWS = `${ApiBase}/calendar/workflows`
const APPOINTMENT_TYPES = `${ApiBase}/calendar/appointment_types`
const PROVIDER_AVAILABILITY = `${ApiBase}/calendar/provider_availability`

// TEAM
const GET_TEAM_LIST = `${ApiBase}/teams`
const INVITE_USER = `${ApiBase}/users/invite`
const TEAM_USER_ID = (id) => `${ApiBase}/users/${id}`
const TEAM_USER_REMIND = `${ApiBase}/users/remind`
const TEAM_CONFIG = `${ApiBase}/team_config`
const TEAM_CONFIG_ID = (id) => `${ApiBase}/team_config/${id}`
const PUBLIC_TEAM_CONFIG_ID = (id) => `${ApiBase}/team_config/public/${id}`
const ELATION_CREDENTIALS = `${ApiBase}/teams/mine/elation/credentials`
const SOCIAL_TEAM = `${AuthApiBase}/accounts/social/team/`

// PAYMENT
const CONFIG = `${ApiBase}/payments/config`
const PORTAL_SESSION = `${ApiBase}/payments/create-customer-portal-session`
const PLANS = `${ApiBase}/payments/plans`
const SETUP_INTENT = `${ApiBase}/payments/create-setup-intent`
const SET_DEFAULT_PAYMENT = `${ApiBase}/payments/confirm-payment-method`

// FORM BUILDER
const BUILDER_FORM = `${ApiBase}/forms/create`
const BUILDER_FORM_WITH_PDF = `${ApiBase}/forms/with_pdf`
const BUILDER_FORM_ID = (formId) => `${ApiBase}/forms/${formId}`
const BUILDER_FORM_ID_UPDATE = (formId) => `${ApiBase}/forms/${formId}/update`
const BUILDER_PAGE_ID = (pageId) => `${ApiBase}/pages/${pageId}`
const BUILDER_SECTION_ID = (sectionId) => `${ApiBase}/sections/${sectionId}`
const BUILDER_ROW_ID = (rowId) => `${ApiBase}/rows/${rowId}`
const BUILDER_QUESTION_ID = (questionId) => `${ApiBase}/questions/${questionId}`
const BUILDER_QUESTION_CHOICE_ID = (questionChoiceId) =>
  `${ApiBase}/question_choice/${questionChoiceId}`
const BUILDER_QUESTION_COLUMN_ID = (id) => `${ApiBase}/question_column/${id}`
const BUILDER_QUESTION_ROW_ID = (id) => `${ApiBase}/question_row/${id}`
const BUILDER_CONDITIONAL_RULE_ID = (id) => `${ApiBase}/conditional_rule/${id}`
const BUILDER_CONDITIONAL_RULE_GROUP_ID = (id) =>
  `${ApiBase}/conditional_rule_group/${id}`
const BUILDER_QUESTION_VALIDATION_TYPES = `${ApiBase}/questions/validation_types`
const BUILDER_FORM_FORM_DELETE_RESOURCE_ID = (id) =>
  `${ApiBase}/forms/${id}/delete_resources`

const RESOURCE_SETTINGS_ID = (id) => `${ApiBase}/resource-settings/${id}`

// STRIPE
const STRIPE_ACCOUNT = `${ApiBase}/stripe/me/account`
const STRIPE_CUSTOMERS = `${ApiBase}/stripe/customers`

// GOOGLE
const GOOGLE_INTEGRATION = `${ApiBase}/google/me/integration`

// ELATION
const MY_SYNCS = `${ApiBase}/elation/syncs/mine`
const PROVIDERS = `${ApiBase}/elation/providers/mine`

// TEMPLATES
const TEMPLATE_LIST = `${ApiBase}/templates`

const TEMPLATE_ID = (id) => `${ApiBase}/templates/${id}`

// SCHEDULER
const SCHEDULER = `${ApiBase}/scheduler`

const CREATE_APPOINTMENT = `${ApiBase}/appointments`

const APPOINTMENT_SETTINGS = (messageCode: string) =>
  `${ApiBase}/appointment-settings/${messageCode}`

// MESSAGE
const INVALIDATE_MESSAGE = `${ApiBase}/message/invalidate_code`
const PUBLIC_MESSAGE = (messageCode: string) =>
  `${ApiBase}/public-messages/${messageCode}/`

const CREATE_MESSAGE = `${ApiBase}/message`

// Permissions
const MEMBERSHIP_GROUPS = `${ApiBase}/membership_permission_groups`
const LIST_PERMISSIONS = `${ApiBase}/permissions`

// Insurance
const PUBLIC_INSURANCE_COMPANIES = ({ messageCode, packetMessageCode }) =>
  `${ApiBase}/insurance_companies/${messageCode}/public?packet_message_code=${packetMessageCode}`
const INSURANCE_COMPANIES = `${ApiBase}/insurance_companies`

// Routines
const LIST_CREATE_ROUTINES = (customerId: string) =>
  `${ApiBase}/routines/${customerId}/`
const GET_UPDATE_DELETE_ROUTINES = (customerId: string, routineId: string) =>
  `${ApiBase}/routines/${customerId}/${routineId}/`

export const API = {
  AUTH: {
    FORGOT_PASSWORD,
    LOGIN,
    LOGIN_SOCIAL,
    DEPRECATED_LOGIN_SOCIAL,
    LOGOUT,
    SET_PASSWORD,
    RESET_PASSWORD,
    SIGNUP,
    USER_ME,
    VERIFY_RESET_PASSWORD,
    VERIFY_USER,
    SET_VERIFY_USER,
    CHANGE_PASSWORD,
    CHANGE_EMAIL,
    EMAIL_CHANGE_VERIFY,
    SOCIAL_PROVIDERS,
    RESEND_VERIFICATION_EMAIL,
    COGNITO_SYNC,
  },
  RESOURCE: {
    GET_RESOURCE,
  },
  FORM: {
    GET_FORMS,
    CONVERT_FORMS,
    GET_TIME_AND_IP,
    CLONE: CLONE_FORM,
    CALCULATION_RESULT,
    PUBLIC_INSURANCE_COMPANIES,
    INSURANCE_COMPANIES,
  },
  CLIENTS: {
    MERGE: CLIENTS_MERGE,
  },
  CALENDAR: {
    APPOINTMENTS,
    WORKFLOWS,
    APPOINTMENT_TYPES,
    PROVIDER_AVAILABILITY,
  },
  TEAM: {
    GET_TEAM_LIST,
    INVITE_USER,
    TEAM_USER_ID,
    TEAM_USER_REMIND,
    TEAM_CONFIG,
    TEAM_CONFIG_ID,
    PUBLIC_TEAM_CONFIG_ID,
    ELATION_CREDENTIALS,
    SOCIAL_TEAM,
  },
  PAYMENT: {
    CONFIG,
    PORTAL_SESSION,
    PLANS,
    SETUP_INTENT,
    SET_DEFAULT_PAYMENT,
  },
  FORM_BUILDER: {
    FORM: BUILDER_FORM,
    FORM_WITH_PDF: BUILDER_FORM_WITH_PDF,
    FORM_ID: BUILDER_FORM_ID,
    FORM_ID_UPDATE: BUILDER_FORM_ID_UPDATE,
    PAGE_ID: BUILDER_PAGE_ID,
    SECTION_ID: BUILDER_SECTION_ID,
    ROW_ID: BUILDER_ROW_ID,
    QUESTION_ID: BUILDER_QUESTION_ID,
    QUESTION_CHOICE_ID: BUILDER_QUESTION_CHOICE_ID,
    QUESTION_COLUMN_ID: BUILDER_QUESTION_COLUMN_ID,
    QUESTION_ROW_ID: BUILDER_QUESTION_ROW_ID,
    CONDITIONAL_RULE_ID: BUILDER_CONDITIONAL_RULE_ID,
    CONDITIONAL_RULE_GROUP_ID: BUILDER_CONDITIONAL_RULE_GROUP_ID,
    RESOURCE_SETTINGS_ID,
    BUILDER_QUESTION_VALIDATION_TYPES,
    BUILDER_FORM_FORM_DELETE_RESOURCE_ID,
  },
  TEMPLATES: {
    LIST: TEMPLATE_LIST,
    DETAIL: TEMPLATE_ID,
  },
  STRIPE: {
    ACCOUNT: STRIPE_ACCOUNT,
    CUSTOMERS: STRIPE_CUSTOMERS,
  },
  GOOGLE: {
    INTEGRATION: GOOGLE_INTEGRATION,
  },
  ELATION: {
    MY_SYNCS,
    PROVIDERS,
  },
  SCHEDULER: {
    ROOT: SCHEDULER,
    CREATE_APPOINTMENT,
    APPOINTMENT_SETTINGS,
  },
  MESSAGE: {
    INVALIDATE_MESSAGE,
    PUBLIC_MESSAGE,
    CREATE_MESSAGE,
  },
  PERMISSIONS: {
    MEMBERSHIP_GROUPS,
    LIST_PERMISSIONS,
  },
  ROUTINES: {
    LIST_CREATE_ROUTINES,
    GET_UPDATE_DELETE_ROUTINES,
  },
}
